import React, { FC } from "react";
import Image from "next/image";
import getConfig from "next/config";
import { Button } from "../../Button";
import { Heading } from "../../Heading";
import { getCloudflareLoader } from "../../../helpers/cloudflareImages";
import {
  StyledButtonWrapper,
  StyledContent,
  StyledEmptyCart,
  StyledMsg,
  StyledTitle,
} from "./index.styled";

const { publicRuntimeConfig } = getConfig();

interface EmptyCartProps {
  cdnEndpoint: string;
  href?: string;
  showTitle?: boolean;
}

export const EmptyCart: FC<EmptyCartProps> = ({
  cdnEndpoint,
  href = "/",
  showTitle,
}) => {
  return (
    <StyledEmptyCart data-testid="empty-cart">
      {showTitle && (
        <StyledTitle>
          <Heading level="h1" size="xl">
            My Cart
          </Heading>
        </StyledTitle>
      )}
      <StyledContent>
        <Image
          src={`${cdnEndpoint}/static-images/cart_zerostate.svg`}
          alt="Box with parachute"
          width="80"
          height="70"
          loader={getCloudflareLoader(publicRuntimeConfig.cdn)}
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />
        <StyledMsg>
          Your cart is currently empty. Start shopping to fill it up!
        </StyledMsg>
        <StyledButtonWrapper>
          <Button internalLink={href} type="secondary" fullWidth>
            Shop Now
          </Button>
        </StyledButtonWrapper>
      </StyledContent>
    </StyledEmptyCart>
  );
};
